import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import MenuIcon from 'material-ui/svg-icons/navigation/menu';
import Cell from 'material-ui/svg-icons/action/announcement';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Popover from 'material-ui/Popover';
import IconButton from 'material-ui/IconButton';

import ContentWrapper from 'components/ContentWrapper';
import VerticalMiddler from 'components/VerticalMiddler';
import FeedbackContainer from 'containers/FeedbackContainer';
import { dimensions } from 'styles/provider';

// import { getToken } from 'lib/challengeToken';
import { shouldAllowUnauthorized } from 'lib/authorizedRoutes';

import { header, appointment, feedback, profile, headerTool, login, logout } from './Header.less';
import logo from './assets/myms.png';
import logoutIcon from './assets/logout.svg';
import LanguageSelector from './LanguageSelector';
import doLogout from 'lib/doLogout';
import { actions } from 'store/session';

const wWidth = window.innerWidth;

const isSmall = wWidth <= 1023;

const burgerStyle = {
  color: 'white',
  style: {
    width: 36,
    height: 36,
    marginTop: -6,
  },
};

const cellStyle = {
  color: '#81c5c0',
  style: {
    width: 28,
    height: 28,
    marginTop: -2,
  },
};

class Header extends React.Component {
  static propTypes = {
    lang: PropTypes.string,
    dispatch: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
      fbOpen: false,
    };
  }

  handleTouchTap = event => {
    event.preventDefault();

    this.setState({
      menuOpen: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = (url = null) => {
    this.setState({
      menuOpen: false,
    });
    if (url) window.location.href = url;
  };

  handleFBVisible = open => {
    this.setState({ fbOpen: open });
  };

  changeLanguage = lang => {
    this.props.dispatch(actions.updateLanguage(lang));
  };

  createMenuBurger() {
    return (
      <div style={{ height: '100%' }}>
        <IconButton iconStyle={burgerStyle.style} onClick={this.handleTouchTap}>
          <MenuIcon color={burgerStyle.color} />
        </IconButton>
        <Popover
          open={this.state.menuOpen}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
          onRequestClose={e => this.handleRequestClose()}
        >
          <Menu>
            <MenuItem onClick={e => this.handleRequestClose('/documents/next')}>
              <FormattedMessage id="next.title" />
            </MenuItem>
            <MenuItem
              onClick={() => {
                this.handleRequestClose();
                this.handleFBVisible(true);
              }}
            >
              <FormattedMessage id="header.actions.feedback" />
            </MenuItem>
            <MenuItem onClick={e => this.handleRequestClose('/documents/profile')}>
              <FormattedMessage id="dictionary.vaultProfile" />
            </MenuItem>
            <MenuItem
              rightIcon={<ArrowDropRight />}
              menuItems={[
                <MenuItem onClick={() => this.changeLanguage('fi')}>
                  <FormattedMessage id="languages.fi" />
                </MenuItem>,
                <MenuItem onClick={() => this.changeLanguage('sv')}>
                  <FormattedMessage id="languages.sv" />
                </MenuItem>,
                <MenuItem onClick={() => this.changeLanguage('en')}>
                  <FormattedMessage id="languages.en" />
                </MenuItem>,
              ]}
            >
              <FormattedMessage id="dictionary.changeLanguage" />
            </MenuItem>
            <MenuItem onClick={e => doLogout()}>
              <FormattedMessage id="header.actions.logout" />
            </MenuItem>
          </Menu>
        </Popover>
      </div>
    );
  }

  render() {
    return (
      <div className={header}>
        <FeedbackContainer visible={this.state.fbOpen} openDialog={this.handleFBVisible} />
        <ContentWrapper>
          <Grid fluid>
            <Row middle="xs" start={isSmall ? 'xs' : 'sm'} center={!isSmall ? 'xs' : undefined}>
              <Col xs={isSmall ? 9 : 12} sm={3} md={2} lg={2}>
                <VerticalMiddler wrapperHeight={dimensions.headerHeight}>
                  <Link to="/" style={{ textDecoration: 'none' }}>
                    <img alt="StellarQ My MS" src={logo} height={dimensions.headerLogoHeight} />
                    {this.props.orgName && (
                      <div
                        style={{
                          fontSize: '1.2rem',
                          textAlign: 'center',
                        }}
                      >
                        {this.props.orgName}
                      </div>
                    )}
                  </Link>
                </VerticalMiddler>
              </Col>
              {!shouldAllowUnauthorized(window.location.pathname) && (
                <Col xs={0} sm={6} md={8} lg={8}>
                  {!isSmall && (
                    <Row end="xs" middle="xs">
                      <Col xs={12} sm={2} md={1} lg={1} style={{ display: 'flex', justifyContent: 'center' }}>
                        {this.props.recommendApp && (
                          <IconButton iconStyle={cellStyle.style} onClick={this.props.toggleDialog}>
                            <Cell color={cellStyle.color} />
                          </IconButton>
                        )}
                      </Col>
                      <Col xs={12} sm={6} md={4} lg={4} className={appointment}>
                        <Link to="/documents/next">
                          <h6>
                            <FormattedMessage id="next.title" />
                          </h6>
                        </Link>
                      </Col>
                      <Col xs={12} sm={6} md={4} lg={2} className={feedback}>
                        <h6 onClick={() => this.handleFBVisible(true)}>
                          <FormattedMessage id="header.actions.feedback" />
                        </h6>
                      </Col>
                      <Col xs={12} sm={3} md={2} lg={2} className={profile}>
                        <Link to="/documents/profile">
                          <h6>
                            <FormattedMessage id="profile.title" />
                          </h6>
                        </Link>
                      </Col>
                      <Col xs={12} sm={3} md={1} lg={1} className={profile}>
                        <LanguageSelector lang={this.props.lang} changeLanguage={this.changeLanguage} />
                      </Col>
                    </Row>
                  )}
                </Col>
              )}
              {!shouldAllowUnauthorized(window.location.pathname) && (
                <Col xs={isSmall ? 3 : 12} sm={3} md={2} lg={2}>
                  {isSmall && (
                    <Row end="xs" className={headerTool}>
                      {this.createMenuBurger()}
                    </Row>
                  )}
                  {!isSmall && (
                    <Row center="xs" end="sm" className={headerTool}>
                      <Col>
                        <a onClick={e => doLogout()} className={login}>
                          <img className={logout} alt="" src={logoutIcon} />
                          <h6 style={{ fontSize: '1.4rem' }}>
                            <FormattedMessage id="header.actions.logout" />
                          </h6>
                        </a>
                      </Col>
                    </Row>
                  )}
                </Col>
              )}
            </Row>
          </Grid>
        </ContentWrapper>
      </div>
    );
  }
}

Header.propTypes = {
  orgName: PropTypes.string,
  toggleDialog: PropTypes.func,
  recommendApp: PropTypes.bool,
};

const mapStateToProps = s => ({
  lang: s.session ? s.session.lang : null,
});

export default connect(mapStateToProps, null)(Header);
